import React from 'react'
import { FileAttachments } from '@/components/fileAttachments'

class DocumentationAttachments extends React.Component {
  render () {
    if (!this.props.isVisible) { return null }
    return (
      <div style={{ paddingTop: 10 }}>
        <FileAttachments
          singleFile
          attachments={this.props.attachments}
          downloadAction={this.props.downloadAction}
          onChange={this.props.onAttachmentChange} />
      </div>
    )
  }
}

export default DocumentationAttachments



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/documentation/attachments.js